// import React, { useState } from "react";
import { Grid } from "@material-ui/core";

import QuestionSearchWeb from "./QuestionPaper";

export default function Main({ assessment_id, question_count }) {
  return (
    <Grid item xs={12} style={{ paddingBottom: "0" }}>
      <h1 style={{ marginBottom: "0" }}>Answer The Questions:</h1>
      <QuestionSearchWeb assessment_id={assessment_id} question_count={question_count}/>
    </Grid>
  );
}
